export default "__VITE_ASSET__CM_OwUTe__"